export default __webpack_public_path__ + "static/media/bokur75.898b4319.png";